import * as AppPermissions from "@/data/AppPermissions";
import JaggedButton from "../JaggedButton";
import PermissionsContainer from "./PermissionsContainer";
import { MissingBodyText, MissingHeaderText } from "./PermissionsAssets";

const style = {
    corner: Wind.style({
        height: "h-full",
        borderWidth: "border-[1rem]",
        borderColor: "border-transparent",
        borderBottomColor: "border-b-parchment",
        borderLeftColor: "border-l-parchment"
    }),
    modal: Wind.style({
        width: "w-11/12",
    })
};

const PermissionPopup = ({
    permission,
    close,
}: {
    permission: AppPermissions.Permission,
    close: () => void;
}) => (
    <PermissionsContainer color={"bg-[#ECE3D6]"}>
        <div className={style.modal.class}>
            <div className="h-8 flex">
                {/* top bar */}
                <div className="bg-parchment h-full flex-grow" />
                <div className={style.corner.class} />
            </div>
            <div
                className={Wind.style({
                    paddingX: "px-6",
                    textAlign: "text-center",
                    backgroundColor: "bg-parchment"
                }).class}
            >
                {/* title */}
                <h1
                    className={Wind.style({
                        fontSize: "text-xl",
                        fontWeight: "font-bold",
                        textTransform: "capitalize",
                        paddingBottom: "pb-2",
                    }).class}
                >
                    {MissingHeaderText[permission]}
                </h1>
                {/* explanation */}
                <p
                    className={Wind.style({
                        paddingBottom: "pb-6",
                    }).class}
                >
                    {MissingBodyText[permission]}
                </p>
                <div
                    className={Wind.style({
                        display: "flex",
                        paddingBottom: "pb-9",
                        alignItems: "items-center",
                        justifyContent: "justify-center",
                    }).class}
                >
                    <JaggedButton
                        color="text-sharp-red"
                        className="w-2/3 text-parchment font-bold"
                        onClick={() => void AppPermissions.require(permission)
                            .then(okay =>
                            {
                                if (okay) close();
                            })
                            .catch(Logger.warn)}
                    >
                        {"Open settings"}
                    </JaggedButton>
                </div>
            </div>
        </div>
    </PermissionsContainer>
);

export default PermissionPopup;
